import { defineMessage } from 'services/localization';

export const messages = {
    unknownStepName: defineMessage('unknown_step'),
    headerRequesterSubmitted: defineMessage('submitted_request_for_approval'),
    headerApproverApproved: defineMessage('approved_request_in_step_step'),
    headerApproverApprovedStepApproved: defineMessage('approved_request_in_step_step'),
    headerApproverApprovedRequestApproved: defineMessage('approved_request_in_step_step'),
    headerApproverRejected: defineMessage('rejected_request_in_step_step'),
    headerApproverRevoked: defineMessage('revoked_their_vote_from_step_step'),
    headerApproverRevokedStepChanged: defineMessage('revoked_their_vote_requ_turned_back_to_nextstep'),
    headerRequesterClosed: defineMessage('closed_request_with_reject_resolution'),
    headerRequesterCancelled: defineMessage('cancelled_request'),
    headerRequesterReopened: defineMessage('reopened_request_with_following_changes'),
    headerRequesterReopenedWithResetNoChanges: defineMessage('reopened_request'),
    headerRequesterReopenedWithReset: defineMessage('reopened_request_with_following_changes'),
    headerRequesterReopenedStepChangedNoChanges: defineMessage('reopened_request'),
    headerRequesterReopenedStepChanged: defineMessage('requester_reopened_request_with_following_changes'),
    headerRequesterReopenedRequestApprovedNoChanges: defineMessage('reopened_request'),
    headerRequesterReopenedRequestApproved: defineMessage('requester_reopened_request_with_following_changes'),
    headerRequesterUpdated: defineMessage('updated_request_with_following_changes'),
    headerRequesterUpdatedWithResetNoChanges: defineMessage('updated_request'),
    headerRequesterUpdatedWithReset: defineMessage('updated_request_with_following_changes'),
    headerRequesterUpdatedStepChangedNoChanges: defineMessage('updated_request'),
    headerRequesterUpdatedStepChanged: defineMessage('updated_request_with_following_changes'),
    headerRequesterUpdatedRequestApprovedNoChanges: defineMessage('updated_request'),
    headerRequesterUpdatedRequestApproved: defineMessage('updated_request_with_following_changes'),
    headerStepSkipped: defineMessage('step_step_has_been_skip_there_were_no_approvers'),
    headerForcedApproval: defineMessage('forced_approval_of_this_request'),
    headerForcedReject: defineMessage('forced_reject_of_this_request'),
    headerRequesterResetTemplate: defineMessage('started_over_approval_workflow_for_this_request'),
    headerEditorEdited: defineMessage('modified_request_in_step_step'),
    headerEditorEditedStepApproved: defineMessage('modified_and_approved_request_in_step_step'),
    headerEditorEditedRequestApproved: defineMessage('modified_and_approved_request_in_step_step'),
    headerPulledFromSourceRB: defineMessage('created_in_dext_prepare'),
    headerPulledFromSource: defineMessage('pulled_request_from_external'),
    headerPushedToSource: defineMessage('push_decision_for_templatename_to_external'),
    headerDocumentClosed: defineMessage('marked_the_purchase_order_as_closed'),
    headerDocumentOpened: defineMessage('marked_the_purchase_order_as_open'),
    headerDocumentClosedStatusSynced: defineMessage('the_closed_status_has_b_ed_to_quickbooks_online'),
    headerDocumentOpenedStatusSynced: defineMessage('the_open_status_has_bee_ed_to_quickbooks_online'),
    headerAirwallexBatchPaymentRequestPaid: defineMessage('sent_the_request_to_payment'),
    headerAirwallexRequestScheduledForPayment: defineMessage('scheduled_a_payment_for_the_request'),
    headerAirwallexScheduledPaymentCancelled: defineMessage('canceled_the_payment_schedule_for_the_request'),
    headerAirwallexScheduledPaymentFailedDueToPaymentServiceIntegrationDisconnected: defineMessage(
        'failed_to_send_schedule_nnection_with_airwallex'
    ),
    headerAirwallexScheduledPaymentFailedDueToExceededAmountDue: defineMessage(
        'failed_to_send_schedule_pecified_payment_amount'
    ),
    headerAirwallexScheduledPaymentFailedDueToBeneficiaryDiscrepancy: defineMessage(
        'failed_to_send_schedule_en_updated_in_airwallex'
    ),
    headerAirwallexScheduledPaymentFailedDueToInsufficientFunds: defineMessage(
        'failed_to_send_schedule_le_funds_into_airwallex'
    ),
    headerAirwallexScheduledPaymentFailedDueToCompanyIntegrationDisabled: defineMessage(
        'failed_to_send_schedule_disconnection_with_xero'
    ),
    headerMarkedAsSentSynced: defineMessage('the_quote_status_has_been_changed_to_sent'),
    headerAttachmentsAdded: defineMessage('new_files_have_been_attached_via_public_api'),
    headerAttachmentDeleted: defineMessage('a_file_has_been_deleted_via_public_api'),
    headerReviewersChanged: defineMessage('changed_the_reviewers'),
    headerReviewForcedByAdmin: defineMessage('forced_the_review_of_the_request'),
    headerReviewCompleted: defineMessage('completed_the_review_an_he_request_for_approval'),
    headerReturnedToReview: defineMessage('returned_the_request_to_review'),
    headerReviewerEdited: defineMessage('edited_the_request_in_review_step'),
    headerApproverEdited: defineMessage('edited_the_request_in_step'),
    headerRequestPutOnHold: defineMessage('has_put_request_on_hold_with_the_following_comment'),
    headerRequestTakenOffHold: defineMessage('has_returned_request_to_h_the_following_comment'),
    headerRequestApproverNudgedReviewStep: defineMessage('all_reviewers_are_mentioned'),
    headerRequestApproverNudgedApprovalStep: defineMessage('approvers_of_the_curren_t_yet_voted_were_nudged'),
    changeNewName: defineMessage('changed_name'),
    changeChangedDescription: defineMessage('changed_description'),
    changeRemovedDescription: defineMessage('removed_description'),
    changeChangedAmount: defineMessage('changed_amount_amount'),
    changeChangedField: defineMessage('changed_name_value'),
    changeAddedAttachments: defineMessage('added_documents_attachments'),
    changeRemovedAttachments: defineMessage('removed_documents_attachments'),
    stepChangeAddedApprover: defineMessage('added_approver_as_approver_to_the_stepname_step'),
    stepChangeRemovedApprover: defineMessage('removed_approver_from_the_stepname_step_approvers'),
    stepChangeChangedDeadline: defineMessage('set_deadline_deadline_for_stepname'),
    stepChangeRemovedDeadline: defineMessage('removed_deadline_for_stepname'),
    stepChangeAddedReviewer: defineMessage('added_reviewer_as_reviewer'),
    stepChangeRemovedReviewer: defineMessage('removed_reviewer_from_reviewers'),
    footerApproverApprovedStepApproved: defineMessage('all_approvals_for_the_s_cted_next_step_nextstep'),
    footerApproverApprovedRequestApprovedAirwallex: defineMessage('all_approvals_for_the_r_est_is_awaiting_payment'),
    footerApproverApprovedRequestApproved: defineMessage('all_approvals_for_the_r_d_and_request_is_closed'),
    footerApproverRevokedStepChanged: defineMessage('request_returned_back_to_nextstep_step'),
    footerRequesterReopenedWithReset: defineMessage('request_is_now_in_nextstep_step'),
    footerRequesterReopenedStepChanged: defineMessage('because_approvers_were___moved_to_nextstep_step'),
    footerRequesterReopenedRequestApproved: defineMessage('because_some_approvers__d_and_request_is_closed'),
    footerRequesterUpdatedWithReset: defineMessage('request_is_now_in_nextstep_step'),
    footerRequesterUpdatedStepChanged: defineMessage('because_some_approvers___moved_to_nextstep_step'),
    footerRequesterUpdatedRequestApproved: defineMessage('because_some_approvers__d_and_request_is_closed'),
    footerStepSkipped: defineMessage('request_is_now_in_nextstep_step'),
    footerStepSkippedRequestApproved: defineMessage('this_request_has_been_a_o_the_approval_workflow'),
    footerParticipantsWereChangedRequestApproved: defineMessage('all_approvals_for_the_r_d_and_request_is_closed'),
    footerEditorEditedStepApproved: defineMessage('all_approvals_for_the_s_cted_next_step_nextstep'),
    footerEditorEditedRequestApproved: defineMessage('all_approvals_for_the_r_d_and_request_is_closed'),
    footerStepSkippedRequestRejected: defineMessage('this_request_has_been_a_s_of_the_approval_steps'),
    footerReviewSkipped: defineMessage('review_step_has_been_sk_ions_of_the_review_step'),
};
